import type { LgvRadioOption } from "./radioOptions";
import {
  normalizeCompositeRadioOptions,
  normalizeQuestionRadioOptions,
} from "./radioOptions";

export type LgvCheckboxOption = LgvRadioOption;

export { normalizeQuestionRadioOptions as normalizeQuestionCheckboxOptions };
export { normalizeCompositeRadioOptions as normalizeCompositeCheckboxOptions };

/** Coerce saved scalar or array checkbox answers into an array. */
export function coerceToCheckboxArray(value: unknown): unknown[] {
  if (Array.isArray(value)) return value;
  if (value != null && value !== "") return [value];
  return [];
}

export function isCheckboxOptionSelected(
  selected: unknown[],
  optionValue: string | number | boolean,
): boolean {
  return selected.some((item) => String(item) === String(optionValue));
}

export function toggleCheckboxOption(
  selected: unknown[],
  optionValue: string | number | boolean,
  checked: boolean,
): unknown[] {
  if (checked) {
    if (isCheckboxOptionSelected(selected, optionValue)) return selected;
    return [...selected, optionValue];
  }
  return selected.filter((item) => String(item) !== String(optionValue));
}
